export default "__VITE_ASSET__DNxtTsTh__"